import React from 'react';

import '../../assets/css/App.css';
import MainContent from '../../components/mainContent/MainContent';
import AuditoriaDetalle from './components/AuditoriaDetalle';
  
export default function indexDetalle() {

    return (
         <MainContent titulo='Auditoria Detalle' component={ <AuditoriaDetalle /> } />        
    );
  }